<template>
    <v-card class="padding">
        <v-dialog v-model="atendimento.modal" fullscreen="fullscreen" hide-overlay="hide-overlay" transition="dialog-bottom-transition">
            <ConversaHistorico :atendimento="atendimento.protocolo" @close="atendimento.modal=false" />
        </v-dialog>
        <h1 class="fonte">Filtro de Conversas</h1>
        <p class="black--text">Obtenha dados precisos configurando o filtro abaixo</p>
        <v-layout row>
            <v-flex xs2>
                <v-menu ref="inicio" :close-on-content-click="false" v-model="calendar1" :nudge-right="40" :return-value.sync="picker.dataInicial" lazy="lazy" transition="scale-transition" offset-y="offset-y" full-width="full-width" min-width="290px">
                    <v-text-field slot="activator" color="red" v-model="formatDateInicial" label="Data Inicial" prepend-icon="event" readonly="readonly"></v-text-field>
                        <v-date-picker v-model="picker.dataInicial" no-title="no-title" scrollable="scrollable" locale="pt-br" hint="DD/MM/YYYY format">
                            <v-spacer></v-spacer>
                        <v-btn flat="flat" @click="calendar1=false">Cancelar</v-btn>
                        <v-btn flat="flat" @click="$refs.inicio.save(picker.dataInicial),calendar1=false">OK</v-btn>
                        </v-date-picker>
                </v-menu>
            </v-flex>

            <v-flex xs2>
                <v-menu ref="fim" :close-on-content-click="false" v-model="calendar2" :nudge-right="40" :return-value.sync="picker.dataFinal" lazy="lazy" transition="scale-transition" offset-y="offset-y" full-width="full-width" min-width="290px">
                    <v-text-field slot="activator" color="red" v-model="formatDateFinal" label="Data Final" prepend-icon="event" readonly="readonly"></v-text-field>
                    <v-date-picker v-model="picker.dataFinal" no-title="no-title" scrollable="scrollable" locale="pt-br" hint="DD/MM/YYYY format">
                        <v-spacer></v-spacer>
                        <v-btn flat="flat" @click="calendar2=false">Cancelar</v-btn>
                        <v-btn flat="flat" @click="$refs.fim.save(picker.dataFinal),calendar2=false">OK</v-btn>
                    </v-date-picker>

                </v-menu>
            </v-flex>

            <v-flex class="pt-4">
                <v-icon @click="filtrarpordata">search</v-icon>
            </v-flex>

        </v-layout>





        <v-divider class="mt-3"></v-divider>
        <v-card-title style="margin-top:50px;">
            <h1 class="fonte">Atentimentos</h1>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" color="red" append-icon="search" label="Pesquisar" single-line="" hide-details=""></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="getHistoricoArquivados" :search="search" hide-actions="hide-actions">
            <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{props.index + 1}}</td>
                <td class="text-xs-center">{{ props.item.protocolo }}</td>
                <td class="text-xs-center">{{ pegaAgente(props.item)}}</td>
                <td class="text-xs-center">{{ props.item.historico[0].emissor.nome }}</td>
                <td class="text-xs-center">{{ conversorData(props.item.date.primeira) }}</td>
                <td class="text-xs-center">{{ conversorData(props.item.date.ultima) }}</td>
                <!--<td class="text-xs-center">{{ tempoTotal(props.item.date.primeira, props.item.date.ultima) }}</td>-->
                <td class="text-xs-center">
                    <v-btn class="white--text" fab color="fundo" @click="atendimento.protocolo=props.item.protocolo, atendimento.modal=true">
                        <v-icon>open_in_new</v-icon>
                    </v-btn>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning"> Sua busca por &quot;{{ search }}&quot; não retornou resultados.</v-alert>
        </v-data-table>
    </v-card>

</template>


<script>
  import ConversaHistorico from '../modais/ConversaHistorico'
  import { mapActions, mapGetters } from 'vuex'
  import moment from 'moment'
  export default {
    components:{
      ConversaHistorico
    },
    data () {
      return {
        atendimento:{
          modal:false,
          protocolo: '',
          chat:{}
        },
        calendar1: false,
        calendar2: false,
        picker:{
          dataInicial: moment(new Date()).format('YYYY-MM-DD'),
          dataFinal: moment(new Date()).format('YYYY-MM-DD')
        },
        filtros:{
          nome:'',
          dataInicial: new Date().setHours(0,0,0,0),
          dataFinal: new Date().setHours(23,59,59,0)
        },
        search: '',
        headers: [
          { text: 'Indíce', value: 'index', align:'center' },
          { text: 'Protocolo', value: 'protocolo', align:'center' },
          { text: 'Agente', value: 'agente', align:'center' },
          { text: 'Taxista', value: 'taxista', align:'center' },
          { text: 'Primeira Mensagem', value: 'date.primeira', align:'center' },
          { text: 'Última Mensagem', value: 'date.ultima', align:'center' },
          //{ text: 'Tempo Total', value: 'tempototal', align:'center' },
          { text: 'Ação', value: 'acao', align:'center' }
        ],
        mensagens: [
          {
            value: false,
            agente: "barreto",
            taxista: "klerison",
            data: "24/12/1997",
            tempototal: "4:00:01"
          },
        ]
      }
    },
    computed:{
      ...mapGetters('pxtalk', ['getChamados']),
      formatDateInicial()
      {
        if (!this.picker.dataInicial) return null
        const [year, month, day] = this.picker.dataInicial.split('-')
        return `${day}/${month}/${year}`
      },
      formatDateFinal()
      {
        if (!this.picker.dataFinal) return null
        const [year, month, day] = this.picker.dataFinal.split('-')
        return `${day}/${month}/${year}`
      },

      getHistoricoArquivados()
      {
        return this.getChamados.filter( h => {
          let ultima = new Date( h.date.ultima )
          let inicio = new Date(this.filtros.dataInicial)
          let final  = new Date(this.filtros.dataFinal)
          return ultima  >= inicio && ultima <= final
        })
      }
    },
    methods: {
        conversorData(data)
        {
            return moment(data).format('DD/MM/YYYY HH:mm:ss')
        },

        filtrarpordata()
        {
            let inicio = new Date( this.picker.dataInicial )
            inicio   = inicio.setHours(0,0,0,0)
            inicio   = new Date( inicio )
            inicio   = inicio.setDate(inicio.getDate() + 1)

            let fim = new Date( this.picker.dataFinal )
            fim     = fim.setHours(23,59,59,0)
            fim     = new Date( fim )
            fim     = fim.setDate(fim.getDate() + 1)

            this.filtros.dataInicial = inicio
            this.filtros.dataFinal   = fim
        },
        /*tempoTotal(primeira, ultima)
        {
            let d1 = new Date(primeira).getTime()
            let d2 = new Date(ultima).getTime()

            console.log(d1, d2)

            let res = (d2 - d1) / 1000

            console.log(res)

            return (moment.utc(res * 1000).format('HH:mm:ss'))
        },*/
        pegaAgente(chamado)
        {

            let cliente = []

            for(let i in chamado.historico) {
                if(!chamado.historico[i].receptor  &&  (chamado.historico[i].emissor.remetente == 'redirect' || chamado.historico[i].emissor.remetente == 'agent')) {
                    cliente.push(chamado.historico[i].emissor.nome)
                }

                else if(chamado.historico[i].receptor  && chamado.historico[i].receptor.remetente == 'agent') {
                    cliente.push(chamado.historico[i].receptor.nome)
                }
            }

            let unique = []

            cliente.forEach( ag => {  if( !unique.find( ff => ag == ff ) ){unique.push(ag)} } )


            return chamado.agente = unique.length > 0 ? unique[unique.length - 1] : 'Não foi atendida'
        }
    },
  }
</script>


<style lang="stylus">
  .inputdate
    margin-top 30px
    border-bottom 1px solid #cccccc
    background-color #eee
    padding 8px
    border-radius 3px
    margin-right 10px


  .painel-pesquisa
    display flex
    justify-content space-between



</style>



// WEBPACK FOOTER //
// src/components/user/pxtalk/HistoricoAtendimento.vue